import { Icon } from '@chakra-ui/react';

export const YoutubeIcon = (props: any) => (
  <Icon aria-label="youtube icon" {...props}>
    <path
      d="m6 4c-1.1045695 0-2 .8954305-2 2v12c0 1.1045695.8954305 2 2 2h12c1.1045695 0 2-.8954305 2-2v-12c0-1.1045695-.8954305-2-2-2zm0-2h12c2.209139 0 4 1.790861 4 4v12c0 2.209139-1.790861 4-4 4h-12c-2.209139 0-4-1.790861-4-4v-12c0-2.209139 1.790861-4 4-4zm2 6h8c1.1045695 0 2 .8954305 2 2v4c0 1.1045695-.8954305 2-2 2h-8c-1.1045695 0-2-.8954305-2-2v-4c0-1.1045695.8954305-2 2-2zm2 2v4l4-2z"
      fill="currentColor"
    />
  </Icon>
);
